import React, { useEffect } from "react";

import {
  Box,
  Grid,
  Typography,
  Button,
  Backdrop,
  CircularProgress 
} from "@mui/material";

import {
  useStyles,

} from "../../../shared/styles/common";
import dompurify from "dompurify";
import { ReservationProps } from "../../reservationType";
import { registerLocale } from "react-datepicker";

import de from "date-fns/locale/de";
import es from "date-fns/locale/es";
import fr from "date-fns/locale/fr";
import { useDispatch, useSelector } from "react-redux"; 

import "react-datepicker/dist/react-datepicker.css";
import CompactJourneyDetailsView from "../Shared/compactJourneyDetailsView";

import {
  clearAlertMessage,
  showErrorAlertMessage    
} from "components/store/actions/shared/alertActions";


import { useTranslation } from "react-i18next";
import { authService } from "services/authService";
import IndividualCardPayment from "./individualCardPayment";
import StoredCardPayment from "./storedCardPayment";
import axiosInstance from "helpers/axiosInstance";
import { broadcastAnnouncement } from "components/store/actions/shared/announcementActions";
import { StoredCardDetails } from "./paymentType";
import { AppState } from "components/store/reducers/rootReducer"; 


const PaymentForm: React.FC<ReservationProps> = (props) => {
  const classes = useStyles();  
  const [loading, setLoading] = React.useState(true);  
  const [canContinue, setCanContinue] = React.useState(false);
  const [isStoredCard, setIsStoredCard] = React.useState(false);
  const [dataLoaded, setDataLoaded] = React.useState(false);  
  const [storedCardResult,setStoredCardResult] = React.useState<StoredCardDetails| null>(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const titleRef = React.useRef<HTMLDivElement>(null);
  const sanitizedHtml = dompurify.sanitize(t("lblSecureConnection", {usrlocale : authService.getUserLocale()}),  { ADD_ATTR: ['target'] });
  let drRes = useSelector((state: AppState) => state.dailyRental.reservation);
  
  registerLocale("de", de);
  registerLocale("es", es);
  registerLocale("fr", fr);
  
  
const handleCanContinue = (data) => {
  setCanContinue(data);
}

const handleStoredCard = (data) => {
  setIsStoredCard(data);
}
const getStoredCardDetails = async () => {
     let userId;
     if(drRes?.driverViewModelForBOBO?.boboId){
      userId = drRes?.driverViewModelForBOBO?.boboId;
     }
     else{
     userId = authService.getUserId();
     }  
     setLoading(true);
         
    await axiosInstance
      .get("/paymentstore/getstoredcard/"+ userId )
      .then((res) => {              
        console.log("StoredCardDetails: " ,res)
        setIsStoredCard(res.data.hasStoredCard);  
        setStoredCardResult(res.data);        
        setLoading(false);  
        setDataLoaded(true);
        })
      .catch((err) => {
        console.log("Error in getting Stored Card details ", err);      
        dispatch(showErrorAlertMessage(t("UnexpectedError")));
        dispatch(broadcastAnnouncement(t("UnexpectedError")));  
         setLoading(false);        
         setCanContinue(false);
         setStoredCardResult(null);
         setDataLoaded(true);
      });
  };

useEffect(() => {  
    if(!drRes?.isBoBoFreeText){
    const getStoredCardDetailsFromDb = async () => {
      await getStoredCardDetails();
    }   
    getStoredCardDetailsFromDb();
  }
  else{
    setDataLoaded(true);
    setLoading(false);  
  }
  }, []);
  if (!dataLoaded)
  return <div><Backdrop
  className={classes.backdrop}
  open={loading }
>
  <CircularProgress />
</Backdrop></div>;

  return (
    <Box
      boxShadow={3}
      p={3}
      bgcolor="background.paper"
      style={{ width: "100%"}}
    >
      <Grid container>
        <div ref={titleRef} tabIndex={-1} className={classes.focused}>
          <Typography
            id = "paymentPageTitle"
            variant="h1"
            style={{
              marginTop: 0,
              marginBottom: "15px",
            }}
          >
            {t("ReservationWizard.paymentPageTitle")}
          </Typography>
        </div>
        <CompactJourneyDetailsView
          journeyUId={"00-00"}
          journeyDetails={props.journeyDetails}
        />
      </Grid>
      
      <Backdrop
                className={classes.backdrop}
                open={loading }
              >
                <CircularProgress />
      </Backdrop>
      <Grid item xs={12}style={{marginTop:10}}>
        <span id="lblRequiedFields" style={{ fontWeight: "bold", color: "#000000", textAlign:"left" }}>
          {t("lblRequiedFields")}
        </span>
        </Grid>
      <Grid container style={{width:"100%", textAlign:"center",justifyContent: "center", marginTop:10}}>
        
      <Grid item xs={12}  style={{textAlign:"center", marginTop:20}}> 
        <div id="lblSecureConnection" dangerouslySetInnerHTML={{
            __html: sanitizedHtml,
          }}/>
      </Grid>
      {  dataLoaded &&
      isStoredCard  ? <StoredCardPayment data= {storedCardResult} canContinue={handleCanContinue} updateStoredCardFlag={handleStoredCard} isBobo ={drRes?.isBOBOBooking ?? false}  /> : <IndividualCardPayment canContinue={handleCanContinue} /> 
      }
      
    
      </Grid> 
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "1em",
        }}
      >
        <Button
          id="btnBack"
          color="primary"
          aria-label={t("lblBackToPreviousStep")}
          variant="contained"
          onClick={() => {
            dispatch(clearAlertMessage());
            if (props.handleBack) props.handleBack(0, 0);
          }}
        >
          {t("btnBack")}
        </Button>
        <Button
          id="btnSubmit"
          color="primary"
          variant="contained"
          aria-label={t("lblContinueToNextStep")}
          onClick={() => {
            dispatch(clearAlertMessage());
            if (props.handleNext) props.handleNext(0, 0);
          }}
          disabled={!canContinue}
        >
          {t("btnContinue")}
        </Button>
      </div>
    </Box>
  );
};
export default PaymentForm;